<template>
    <transition name="fade" mode="out-in" appear :duration="5000">
        <section class="alertbar" v-if="alert.any()">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12 text-center">
                        <img src="/img/alert-white.png">
                        {{alert.get()}}
                        <a href="#">{{ trans('Resolve') }}</a>
                    </div>
                </div>
            </div>
        </section>
    </transition>
</template>

<script>
    export default {
        data() {
          return {
              alert: this.$alert
          }
        },
        props: [

        ],
        methods: {

        },
        mounted() {

        }
    }
</script>